import { api } from '@shared/api';
import type { AnalyticsPeriod } from './adminAnalyticsApi';

export interface MetrikaRow {
  name: string;
  visits: number;
  users: number;
  /** null — в Метрике нет цели «регистрация». */
  registrations: number | null;
}

export interface AdminMetrika {
  /** false — токен Метрики не задан, блок выключен. */
  configured: boolean;
  days: AnalyticsPeriod;
  error: string | null;
  visits: number;
  users: number;
  registrations: number | null;
  sources: MetrikaRow[];
  utm: MetrikaRow[];
}

/** GET /api/v1/admin/metrika?days= — визиты и регистрации по источникам из Яндекс Метрики (кэш 15 минут). */
export async function fetchAdminMetrika(days: AnalyticsPeriod): Promise<AdminMetrika> {
  const { data } = await api.get<AdminMetrika>('/admin/metrika', { params: { days } });
  return {
    configured: data.configured,
    days: data.days,
    error: data.error ?? null,
    visits: data.visits ?? 0,
    users: data.users ?? 0,
    registrations: data.registrations ?? null,
    sources: data.sources ?? [],
    utm: data.utm ?? [],
  };
}
